import React from 'react';
import ReactDOM from 'react-dom/client';
import '@link/shibuya-sky/styles/index.css';
import { addSitePassword, captureAffiliateId } from '@link/share/utils';
import {
  initForter,
  initGDPRCookieBanner,
  initRecaptcha
} from '@link/share/vendors';
import '@link/shibuya-sky/i18n';
import '@link/shibuya-sky/vendors/gtm';
import App from '@link/shibuya-sky/App';
import { PRODUCTION_PASSWORD_DEADLINE } from '@link/shibuya-sky/constants';

// Capture the affiliate tag from the entry URL first: anything below can
// replace the document or navigate, and the tag is read from session storage
// from here on.
captureAffiliateId();

// Enable password verification for 'testing' environment, and for 'production'
// until the site officially opens, before React renders
const env = import.meta.env.VITE_APP_SHIBUYA_SKY_ENV as string;
const requirePassword =
  ['testing'].includes(env) ||
  (env === 'production' && new Date() < PRODUCTION_PASSWORD_DEADLINE);
addSitePassword(requirePassword);

initForter(import.meta.env.VITE_APP_FORTER_SITE_ID);
initRecaptcha(import.meta.env.VITE_APP_RECAPTCHA_SITE_KEY);

// Show the Silktide Cookie Banner to GDPR-country visitors before React renders
initGDPRCookieBanner();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
